/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse, HttpContext } from '@angular/common/http';
import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { ApplicationResponse } from '../models/application-response';
import { CreateApplicationMetadata } from '../models/create-application-metadata';


/**
 * Factoring Applications API
 */
@Injectable({
  providedIn: 'root',
})
export class ApplicationsService extends BaseService {
  constructor(
    config: ApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation createApplication
   */
  static readonly CreateApplicationPath = '/applications';

  /**
   * Create a new factoring application.
   *
   * Submits a new factoring application from the console.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `createApplication()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  createApplication$Response(params: {
    context?: HttpContext
    body: {

/**
 * The primary invoice document in PDF format.
 */
'invoice_pdf': Blob;

/**
 * Optional. Other supporting documents.
 */
'other_attachments'?: Array<Blob>;
'metadata': CreateApplicationMetadata;
}
  }
): Observable<StrictHttpResponse<ApplicationResponse>> {

    const rb = new RequestBuilder(this.rootUrl, ApplicationsService.CreateApplicationPath, 'post');
    if (params) {
      rb.body(params.body, 'multipart/form-data');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      context: params?.context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<ApplicationResponse>;
      })
    );
  }

  /**
   * Create a new factoring application.
   *
   * Submits a new factoring application from the console.
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `createApplication$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  createApplication(params: {
    context?: HttpContext
    body: {

/**
 * The primary invoice document in PDF format.
 */
'invoice_pdf': Blob;

/**
 * Optional. Other supporting documents.
 */
'other_attachments'?: Array<Blob>;
'metadata': CreateApplicationMetadata;
}
  }
): Observable<ApplicationResponse> {

    return this.createApplication$Response(params).pipe(
      map((r: StrictHttpResponse<ApplicationResponse>) => r.body as ApplicationResponse)
    );
  }

}
